import { selectFetchingData } from "state/issueCount/selectors";
import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { titleCase } from "@ls/js-utils";
import scope from "./scope";
import { useDispatch, useSelector } from "react-redux";
import { selectDefinitions } from "./selectors";
import React from "react";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.map((definition) => {
      const { issuerCountType, summary } = definition;
      return {
        headerName: `Issuer Count ${titleCase(issuerCountType)}`,
        field: `${scope}, ${issuerCountType}, ${summary}`,
        colId: `${scope}, ${issuerCountType}, ${summary}`,
        loading:
          (summary === SummaryType.ABSOLUTE && fetchingAbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelData),
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };
    });
  }, [definitions, dispatch, fetchingAbsData, fetchingRelData]);
};
